import React from "react";
import { useLayoutHeader } from "../../components/MainLayout";
import { Avatar, Col, Divider, Row, Skeleton, Typography } from "antd";
import scooterIcon from "./scooter-icon.png";
import {
    convertTime2Title,
    timeDurationPresentation,
    jalaaliDatePresentation,
    jalaaliHourPresentation
} from "components/TimePresentation";
import { STATIC_MAP_URL } from "../../constants";
import { format } from "react-string-format";
import './style.css'
import Currency from "components/Currency";

const { Text, Title } = Typography

export function TripDetailView(props) {
    const { ride } = props;
    useLayoutHeader({
        closeable: true,
        pageTitle: ride && convertTime2Title(ride.startTime),
        menuEnabled: false,
        extra: [],
    })
    const discount = ride && ride.order.discountDetails.reduce(function (prev, current) {
        return prev + +current.value
    }, 0)

    return <React.Fragment>
        {ride !== undefined ?
            <React.Fragment>
                <Row className='px-40 mb-36'>
                    <img src={format(STATIC_MAP_URL, ride.startLocation.lat, ride.startLocation.lon)}
                        style={{ width: "100%" }} />
                </Row>
                <div className='px-40 trip-detail'>
                    <Row className='d-none'>
                        <Col span={12}>
                            <Row>
                                <Text>دستگاه مورد استفاده</Text>
                            </Row>
                            <Row>
                                <Title level={4}>{ride.vehicleType === "SCOOTER" ? "اسکوتر" : "دوچرخه"}</Title>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <Avatar shape="square" size={64} icon={<img src={scooterIcon} />} style={{ float: 'left' }} />
                        </Col>
                    </Row>
                    <Divider className='d-none' />

                    <React.Fragment>
                        <Row>
                            <Col span={24} className="">
                                <Title level={2} className='mb-1 f-22'>مشخصات سفر</Title>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className='secondary-text-grey'>
                                <p className='secondary-text-grey'>تاریخ سفر</p>
                            </Col>
                            <Col span={12}>
                                <p className='secondary-text-grey'
                                    style={{ float: 'left' }}>{jalaaliDatePresentation(ride.startTime)}</p>
                            </Col>
                        </Row>
                        <Row className=''>
                            <Col span={12}>
                                <p className='secondary-text-grey'>ساعت شروع - پایان</p>
                            </Col>
                            <Col span={12}>
                                <p className='secondary-text-grey'
                                    style={{ float: 'left' }}>{jalaaliHourPresentation(ride.startTime)}-{jalaaliHourPresentation(ride.finishTime)}</p>
                            </Col>
                        </Row>
                        <Row className='mb-36'>
                            <Col span={12}>
                                <p>مجموع زمان در اختیار</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ float: 'left' }}>{timeDurationPresentation(ride.duration)}</p>
                            </Col>
                        </Row>

                    </React.Fragment>
                    <React.Fragment>
                        <Row>
                            <Col span={24} className="">
                                <Title level={2} className='mb-1 f-22'>هزینه سفر</Title>
                            </Col>
                        </Row>


                        {ride.order.priceDetails.map((priceDetail, index) =>
                            <Row key={index} className='secondary-text-grey'>
                                <Col span={12}>
                                    <p className='secondary-text-grey'>{priceDetail.title}</p>
                                </Col>
                                <Col span={12}>
                                    <p className='secondary-text-grey'
                                        style={{ float: 'left' }}><Currency value={priceDetail.value} /></p>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col span={12}>
                                <p>مجموع هزینه سفر</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ float: 'left' }}><Currency value={ride.order.totalPrice} /></p>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <p>تخفیف</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ float: 'left' }}><Currency value={discount} /></p>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <p>نحوه ی پرداخت</p>
                            </Col>
                            <Col span={12}>
                                <p style={{ float: 'left' }}>{ride.order.paymentMethod}</p>
                            </Col>
                        </Row>
                    </React.Fragment>

                    <Row className='d-none'>
                        <Col span={12}>
                            <p>کد سفر</p>
                        </Col>
                        <Col span={12}>
                            <p style={{ float: 'left' }}>{ride.publicRideId}</p>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
            : <Skeleton />}

    </React.Fragment>
}